// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// 引入全局样式表
import './assets/css/globlcss.css'

import App from './App.vue';
import Router from 'vue-router';
import './api/ajax';
import router from "./router";
import axios from 'axios'
import rules from './api/validate'
import promise from 'es6-promise'
import { logger } from './utils/log';
import { toPercent } from './utils/utils';
import _ from 'lodash'
import "babel-polyfill"
import VueClipboard from 'vue-clipboard2'
import { globalUploadHandler } from '@/utils/globalUploadHandler';

import htmlToPdf from './utils/htmlToPdf'

import echarts from "echarts";

// 全局组件
import globalComponents from './components/common/AFTableColumn' //table宽度自适应
// import AMap from "vue-amap";
// Vue.use(AMap);
import UmyUi from 'umy-ui'
// import 'umy-ui/lib/theme-chalk/index.css'; // 引入样式
Vue.use(UmyUi);
Vue.filter('toPercent', toPercent)

Vue.prototype.$globalUpload = globalUploadHandler; //全局上传压缩处理
//元素转pdf
Vue.use(htmlToPdf)
Vue.use(VueClipboard)
Vue.prototype.Rules = rules;


promise.polyfill();
Vue.prototype.$http = axios;
Vue.config.productionTip = false
Vue.config.errorHandler = logger.error;
Vue.prototype._ = _;
Vue.prototype.isRefresh = false;


Vue.prototype.$echarts = echarts;

// AMap.initAMapApiLoader({
//     key: "011f8982630e524b678d2e7b591cfd3e",
//     plugin: ["AMap.Scale", "AMap.OverView", "AMap.ToolBar", "AMap.MapType"],
//     uiVersion: "1.0.11", // ui库版本，不配置不加载,
//     v: "1.4.4"
//   });

Vue.use(ElementUI);
Vue.use(Router);

//在页面加载时读取sessionStorage里的状态信息
// console.log(sessionStorage.getItem('store'), '缓存中的状态111')
// console.log(JSON.stringify(store.state), '撒打算')
if (sessionStorage.getItem("store")) {
    store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem("store"))))
}
//在页面刷新时将vuex里的信息保存到sessionStorage里
window.onbeforeunload = function() {

    sessionStorage.setItem("store", JSON.stringify(store.state))
}

// to 将要访问的路径
// from 代表从哪个路径跳转而来
// next()  放行   next（'/login'） 强制跳转
router.beforeEach((to, from, next) => {

    // console.log(to,from)
    //  路由加时间戳，用于刷新缓存
    // console.log(to, from);
    // if (to.path == "/businessm/paymentm") {
    //     to.meta.keepAlive = false

    // } else if (to.path == "/financialm/DirverSettlementm") {
    //     to.meta.keepAlive = false

    // } else if (to.path == "/businessm/Waybillm") {
    //     to.meta.keepAlive = false

    // }
    //判断是否直接访问驾驶舱
    if (to.path == "/welcome") {
        var tabs1 = store.state.sharing.tabs;
        if (tabs1.length > 1) {
            next();
            return;
        };
        //判断是否有驾驶舱权限
        var user = store.state.sharing.userInfo;
        var login = localStorage.getItem("login");
        if (!user || !user.userType) {
            user =  login ?  JSON.parse(login) : null;
            if (!user) {
                next("/login"); // 没有登录信息，去登录页
                return;
            }
        }
        var userType = user.userType;
        var res = user.attrs.res;
        if (userType == 1) {
            if (res) {
                var findIndex = res.findIndex(atem => {
                    return atem.name == "平台运营管理"
                })
                var mres = res[findIndex].children;
                var findIndex = mres.findIndex(atem => {
                return atem.name == "驾驶舱"
                })
                if (findIndex > -1) {
                    store.commit("tabs", [{ name: "驾驶舱", path: "/welcome" }]);
                    next(); // 去主页
                } else {         
                    store.commit("tabs", [{ name: "欢迎页", path: "/welcomeY" }]);
                    next("/welcomeY"); // 去主页
                }
            } else {
                store.commit("tabs", [{ name: "欢迎页", path: "/welcomeY" }]);
                next("/welcomeY"); // 去主页
            }
        } else {
            if (res) {
                var findIndex = res.findIndex(atem => {
                return atem.name == "驾驶舱"
                })
                if (findIndex > -1) {
                    store.commit("tabs", [{ name: "驾驶舱", path: "/welcome" }]);
                    next(); // 去主页
                } else {         
                    store.commit("tabs", [{ name: "欢迎页", path: "/welcomeY" }]);
                    next("/welcomeY"); // 去主页
                }
            } else {
                store.commit("tabs", [{ name: "欢迎页", path: "/welcomeY" }]);
                next("/welcomeY"); // 去主页
            }
        }
        return;
    }
    if (to.query.timeOut) {
        next();
        return;
    };
    if (from.query.timeOut) {
        let toQuery = JSON.parse(JSON.stringify(to.query));

        toQuery.timeOut = from.query.timeOut;
        next({
            path: to.path,
            query: toQuery
        })
    } else {
        next()
    }
    //console.log(to,from);
    const token = store.state.sharing.token;

    const passUrl = [
        '/login',
        '/login_admin',
        '/login_carr',
        '/login_shipper',
        '/register_carr',
        '/register_shipper'
    ]
    if (passUrl.includes(to.path)) {
        next()
    }

    // if (!token && !passUrl.includes(to.path)) {
    //     let loginPath = localStorage.getItem("login-path");
    //     if (loginPath) {
    //         debugger
    //         return next({ path: loginPath });
    //     } else {
    //         ElementUI.Message.error({
    //             message: "请回登陆页登陆！",
    //             duration: 0,
    //             showClose: true,
    //         });
    //     }
    //     return false;
    // }
    const tabs = store.state.sharing.tabs;
    var fromTab = getTab(from.path, tabs),
        toTab = getTab(to.path, tabs);

    //console.log('from : ',fromTab);
    //console.log('to   : ' ,toTab);
    var cached = store.state.sharing.cached || [];
    var isSetRoute = store.state.sharing.isSetRoute || [];
    if (!fromTab) { //页面关闭
        removeCached(store, from, cached, isSetRoute);
        // removeCachedViews(store, from); //移除缓存
    }
    addCached(store, to, cached, isSetRoute);
    if (toTab) { //目标tab已经打开
        if (fromTab && fromTab.path == toTab.path) {
            //返回
            if (isCached(to.path, cached)) {
                removeCached(store, from, cached, isSetRoute);
                // removeCachedViews(store, from);
            }
            removeDetail(from.path, fromTab, tabs, store);
        }
        next();
        return;
    }
    if (fromTab) {
        //跳转详情页
        addDetail({ path: to.path, query: to.query }, fromTab, tabs, store);
    }
    next();
});

const addDetail = (detail, tab, tabs, store) => {
    tab.details = tab.details || [];
    tab.details.push(detail);
    store.commit('tabs', tabs);
}

const removeDetail = (path, tab, tabs, store) => {
    tab.details = tab.details || [];
    var ds = [];
    for (var j = 0; j < tab.details.length; j++) {
        var detail = tab.details[j];
        if (detail.path == path) {
            continue;
        }
        ds.push(detail);
    }
    tab.details = ds;
    store.commit('tabs', tabs);
}

const getTab = (path, tabs) => {
    for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        if (tab.path == path) {
            return tab;
        }
        if (containDetail(path, tab)) {
            return tab;
        }
    }
}

const containDetail = (path, tab) => {
    if (!tab.details || tab.details.length == 0) {
        return false;
    }
    for (var j = 0; j < tab.details.length; j++) {
        var detail = tab.details[j];
        if (detail.path == path) {
            return true;
        }
    }
    return false;
}

const isCached = (path, cached) => {
    var c = false;
    if (path && typeof path === 'string') {
        let i = cached.indexOf(path);
        if (i > -1) {
            c = true;
        };
    }
    console.log('isCached : ', path, c);
    return c;
};

const addCached = (store, to, cached, isSetRoute) => {
    console.log('addCached', to.path);
    var path = to.path;
    if (path && typeof path === 'string') {
        let i = cached.indexOf(path);
        if (i < 0) {
            cached.push(path);
            store.commit('cached', cached);
        }
        var findIndex = -1;
        if (isSetRoute.length > 0) {
            findIndex = isSetRoute.findIndex(item => {
                return item.name == to.meta.name
            })
        }
        if (findIndex < 0) {
            var route = {
                name: to.meta.name,
                path: to.path
            }
            isSetRoute.push(route);
            store.commit('isSetRoute', isSetRoute);
        }
    }
};

// 更新要缓存的路由列表
const removeCached = (store, to, cached, isSetRoute) => {
    console.log('removeCached', to.path);
    var path = to.path;
    if (path && typeof path === 'string') {
        let i = cached.indexOf(path);
        if (i > -1) {
            cached.splice(i, 1);
            store.commit('cached', cached);
        }
        var findIndex = -1;
        if (isSetRoute.length > 0) {
            findIndex = isSetRoute.findIndex(item => {
                return item.name == to.meta.name
            })
        }
        if (findIndex > -1) {
            isSetRoute.splice(i, 1);
            store.commit('isSetRoute', isSetRoute);
        }
    }
};

//更新要缓存的缓存列表
const removeCachedViews = (store, route) => {
    var isSetRoute = store.state.sharing.isSetRoute;
    if (isSetRoute.length < 1) {
        return;
    }
    if (route) {
        // debugger
        let i = isSetRoute.findIndex(item => {
            return item.path == route.path
        });
        if (i > -1) {
            isSetRoute.splice(i, 1);

            store.commit('isSetRoute', isSetRoute);
        }
    }
}

const addCachedViews = (store, route, isSetRoute) => {
    // console.log('addCached', route);

    if (route) {
        // debugger
        let i = isSetRoute.findIndex(item => {
            return item.path == route.path
        });
        if (i > -1) {
            return
        }
        isSetRoute.push(route);
        store.commit('isSetRoute', isSetRoute);
    }
};

//定义select分页加载的全局指令
Vue.directive("el-select-loadmore", {
    bind (el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          '.userBank .el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
    }
})



// 引入路由
new Vue({
    el: '#app',
    store,
    router, // 注入到根实例中
    render: h => h(App)
});

//启动日志
logger.start();


// WEBPACK FOOTER //
// ./src/main.js